import React, { createContext, useContext, useState, useCallback } from 'react';

const StateContext = createContext(null);
export const useAppState = () => useContext(StateContext);

export function StateProvider({ children }) {
  const [modelsSidebarOpen, setModelsSidebarOpen] = useState(false);

  const openModelsSidebar = useCallback(() => setModelsSidebarOpen(true), []);
  const closeModelsSidebar = useCallback(() => setModelsSidebarOpen(false), []);
  const setModelsSidebar = useCallback((v) => setModelsSidebarOpen(Boolean(v)), []);

  const value = {
    modelsSidebarOpen,
    openModelsSidebar,
    closeModelsSidebar,
    setModelsSidebar,
  };

  return <StateContext.Provider value={value}>{children}</StateContext.Provider>;
}

export default StateProvider;
